import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Container } from "@/components/layout/container";

export function CTA() {
  return (
    <section className="py-16 sm:py-24">
      <Container>
        <div className="relative overflow-hidden rounded-3xl border border-border bg-accent px-8 py-14 text-center text-accent-foreground">
          <div
            aria-hidden
            className="pointer-events-none absolute -left-20 -top-20 h-64 w-64 rounded-full bg-white/10 blur-3xl"
          />
          <h2 className="relative text-3xl font-bold sm:text-4xl">
            Malam yang Lebih Aman Dimulai dari Sini
          </h2>
          <p className="relative mx-auto mt-4 max-w-xl text-accent-foreground/90">
            Bergabunglah dengan gerakan keamanan malam berbasis teknologi. Gratis untuk komunitas
            percontohan.
          </p>
          <Button
            asChild
            size="lg"
            variant="secondary"
            className="relative mt-8 bg-white text-accent hover:bg-white/90"
          >
            <a href="#kontak">
              Daftar Akses Awal
              <ArrowRight className="h-4 w-4" />
            </a>
          </Button>
        </div>
      </Container>
    </section>
  );
}
